import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Backgrounds = class Backgrounds extends VuexModule {
    constructor() {
        super(...arguments);
        this.backgrounds = [];
        this.cachedVersion = 0;
    }
    async fetchBackgrounds() {
        const { data: backgrounds, cachedVersion } = await fetchFromCache(this, 'backgrounds', 'background');
        return { backgrounds, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['backgrounds', 'cachedVersion'] })
], Backgrounds.prototype, "fetchBackgrounds", null);
Backgrounds = __decorate([
    Module({ namespaced: true, name: 'backgrounds' })
], Backgrounds);
export default Backgrounds;
